/**
 * Defines the top layout which is used across all pages. This includes navigation.
 */
import { Navigation } from "./navigation";

export const LayoutTop = () => {
  return <Navigation />;
};
